<template>

  <svg
    t="1640066472509"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4057"
    width="64"
    height="64"
  ><path d="M188.06 452.66l199.35 120.69a30 30 0 1 1-31.08 51.3L106.46 473.42a30 30 0 0 1 3.99-53.37l780-325.74a30 30 0 0 1 41.01 33.3l-136.65 720a30 30 0 0 1-45.54 19.74L495.95 706.73a30 30 0 0 1 32.1-50.7l216.06 136.98L862.1 171.2 188.06 452.66z" p-id="4058" /><path d="M422 624.59V872a30 30 0 0 1-60 0V610.79a30 30 0 0 1 10.5-22.8L737.18 275.75a30 30 0 0 1 39 45.6L422 624.56z" p-id="4059" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconRelease',
} as DefineComponent
</script>